import { render, staticRenderFns } from "./VideoUploadComponent.vue?vue&type=template&id=02d5136b&scoped=true&"
import script from "./VideoUploadComponent.vue?vue&type=script&lang=js&"
export * from "./VideoUploadComponent.vue?vue&type=script&lang=js&"
import style0 from "./VideoUploadComponent.vue?vue&type=style&index=0&id=02d5136b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d5136b",
  null
  
)

export default component.exports